import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../../../environments/environment";
import { CommonResponse } from "../../../../shared/response/common.response";
import { SecurityService } from "../../../../shared/services/security.service";
import { UtilityService } from "../../../../shared/services/utility.service";
import { Trabajador } from "../../../../shared/models/trabajador.model";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class ApiTrabajadorRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;
    API_ITURRIAPP = environment.API_ITURRIAPP;
    PUBLIC_URI = environment.PUBLIC_URI;

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient, private securityService: SecurityService, private utilityService: UtilityService) {
    }

    public async login(credentials: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'trabajador/login', credentials).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async deleteTokenByToken(token: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'usuario/deleteTokenByToken/' + token).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async obtenerListaPorPaginacion(obj: any): Promise<any> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/listarPorPaginacionPost', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async buscarPorUbigeo(obj: any): Promise<any> {
        try {
            const responseSuccess = await this.http.post('https://api.iturriapp.com/public/rest/msapi/ubigeo/search', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async buscarPorProfesion(obj: any): Promise<any> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'profesion/getProfesion', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async searchTrabajadorListByJefe(obj: any): Promise<any> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/searchTrabajadorByJefe', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async registrar(objeto: Trabajador): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/trabajador', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async editar(objeto: Trabajador): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + 'trabajador/trabajador', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async inactivar(id): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/inactivar/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async activar(id): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/activar/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    /** Reingreso del trabajador cesado en la empresa indicada (la de la barra). */
    public async habilitar(id, empresaId?: number): Promise<CommonResponse> {
        try {
            const conEmpresa = empresaId > 0 ? '/' + empresaId : '';
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/habilitar/' + id + conEmpresa).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getPuestos(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'puesto/getAllActivos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getSedes(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'sede/getAllActivos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getTipificaciones(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getTipificaciones').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    /** Tipos de documento, nacionalidades y paises emisores (tablas de SUNAT). */
    public async getCatalogosIdentidad(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getCatalogosIdentidad').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getEstadoCivilList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/getEstadoCivilList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getEmpresasList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'empresa/getEmpresaList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getGradoInstruccionList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'trabajador/getGradoInstruccionList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }
    public async getDocumentos(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getTiposDocumentos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getTipificacionesAsistencia(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getTipificacionesAsistencia').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getHistorialVacaciones(trabajadorID, pagina, registros, empresaId: any = environment.PARAM.TODOS)
        : Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `trabajador/vacaciones/getHistorialPaginate/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getHistorialDocumentos(trabajadorID, tipoDoc, pagina, registros, empresaId): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `trabajador/documentos/getHistorialPaginate/${trabajadorID}/${tipoDoc}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    // Multas: historial paginado
    public async getHistorialMultas(trabajadorID, pagina, registros, empresaId): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `trabajador/multa/getHistorialPaginate/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    // Obtener datos de una multa (incluye cuotamultaList)
    public async getDataMulta(multaID): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `trabajador/multa/getDataMulta/${multaID}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    // Registrar o editar una multa
    public async registrarMulta(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/multa/guardarMulta', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    // Eliminar una multa
    public async eliminarMulta(id): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.delete(this.API_URI + `trabajador/multa/eliminarMulta/${id}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async generarConvenioPrestamo(multaid): Promise<Blob> {
        try {
            return this.http.post<Blob>(this.API_URI + 'trabajador/multa/generarConvenioPrestamo/' + multaid, null, {
                responseType: 'blob' as 'json'
            }).toPromise();
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async generarConvenioResponsabilidad(multaid): Promise<Blob> {
        try {
            return this.http.post<Blob>(this.API_URI + 'trabajador/multa/generarConvenioResponsabilidad/' + multaid, null, {
                responseType: 'blob' as 'json'
            }).toPromise();
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async registrarDocumento(objeto): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/documentos/registrar', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }


    // Cupones
    public async getHistorialCupones(trabajadorID, pagina, registros, empresaId: any = environment.PARAM.TODOS): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `trabajador/cupon/getHistorialPaginate/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }


    public async getAreas(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'area/getAllActivos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getDataDashboard(objEnvio): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/getDataDashboard', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getDataCumpleanios(objEnvio): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/getCumpleaniosMes', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getPermisos(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'usuario/getPermisos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getImagenSaludoCumpleanios(trabajadorId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(
                this.PUBLIC_URI + 'trabajador/cumpleanios/obtenerImagenSaludo/' + trabajadorId
            ).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getSintomasControlDiario(trabajadorid): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getSintomasControlDiario/' + trabajadorid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async registrarSeguimiento(trabajadorid, objeto: any): Promise<CommonResponse> {
        try {
            const url = this.API_URI + 'trabajador/registrarSeguimiento/' + trabajadorid;
            const responseSuccess = await this.http.post(url, objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async editarSeguimiento(seguimientoid, objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + 'trabajador/editarSeguimiento/' + seguimientoid, objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async obtenerListaPorPaginacionSeguimiento(busqueda: any, pagina: any, registros: any, objeto: any): Promise<CommonResponse> {
        try {
            const url = this.API_URI + 'trabajador/listarPaginacionSeguimiento/' + busqueda + '/' + pagina + '/' + registros;
            const responseSuccess = await this.http.post(url, objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getbyID(trabajadorid): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/trabajador/' + trabajadorid)
                .toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }
    public async getByIdAndEmpresa(trabajadorid, empresaId): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/trabajadorEmpresa/' + trabajadorid + '/' + empresaId)
                .toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getHistorialSeguimiento(trabajadorid: any, pagina: any, registros: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getHistorialSeguimiento/' + trabajadorid + '/' + pagina + '/' + registros).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getSeguimiento(seguimientoid: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getSeguimiento/' + seguimientoid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async darAlta(seguimientoid: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/darAlta/' + seguimientoid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async adjuntarArchivo(file: FormData): Promise<CommonResponse> {
        try {
            // tslint:disable-next-line:max-line-length
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/adjuntarArchivo', file).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async reporteCesePaginado(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/reporteCesePaginado', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async procesarInformacionExcel(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/procesarInformacionExcel', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async procesarDataTrabajadorExcel(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/procesarDataTrabajadorExcel', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async comorbilidadList(trabajadorid): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'comorbilidad/listarPorPaginacion/' + trabajadorid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async addComorbilidad(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'comorbilidad/comorbilidad', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async deleteComorbilidad(id: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.delete(this.API_URI + 'comorbilidad/comorbilidad/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async agregarDias(trabajadorid, objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + 'trabajador/agregarDias/' + trabajadorid, objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async agregarConfiguracionAsistencia(trabajadorid, objeto: any): Promise<CommonResponse> {
        try {
            // tslint:disable-next-line:max-line-length
            const responseSuccess = await this.http.put(this.API_URI + 'trabajador/agregarConfiguracionAsistencia/' + trabajadorid, objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getDias(trabajadorid): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getDias/' + trabajadorid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getConfiguracionAsistencia(trabajadorid): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getConfiguracionAsistencia/' + trabajadorid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getTiposPermisoTrabajador(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/getTiposPermisoTrabajador').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async actualizarFechaMarcacion(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/actualizarFechaMarcacion', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async enviarCorreoAltaPersonal(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/enviarCorreoAltaPersonal').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    /** La persona con ese documento en el grupo (donde estuvo y si esta en la empresa), o null. */
    public async buscarEnGrupo(numero: string, empresaId: any = null): Promise<CommonResponse> {
        try {
            const conEmpresa = empresaId > 0 ? '/' + empresaId : '';
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/buscarEnGrupo/' + encodeURIComponent(numero) + conEmpresa).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    /** Correo de cese de una empresa (la del cese): solo a sus contactos y con los datos de su vinculo. */
    public async enviarCorreoCesePersonal(trabajadorid: any, empresaId: any = null): Promise<CommonResponse> {
        try {
            const conEmpresa = empresaId > 0 ? '/' + empresaId : '';
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/enviarCorreoCesePersonal/' + trabajadorid + conEmpresa).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async generarFotocheck(trabajadorid: any, empresaId: any = null): Promise<Blob> {
        try {
            const empresaIdText = (empresaId > 0 ? '/' + empresaId : '');
            return this.http.post<Blob>(`${this.API_URI}trabajador/${trabajadorid}/fotocheck` + empresaIdText, null, {
                responseType: 'blob' as 'json'
            }).toPromise();
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async validarFotocheck(dni: any): Promise<CommonResponse> {
        try {
            const responseSuccess = this.http.get(`${this.API_URI}trabajador/${dni}/fotocheck`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async reenviarCorreoCesePersonal(trabajadorid: any, empresaId: any = null): Promise<CommonResponse> {
        try {
            const conEmpresa = empresaId > 0 ? '/' + empresaId : '';
            const responseSuccess = await this.http.get(this.API_URI + 'trabajador/reenviarCorreoCesePersonal/' + trabajadorid + conEmpresa).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getDocumentosByTrabajador(trabajadorid: any, empresaId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'documento/getDocumentosByTrabajador/'
                + trabajadorid + '/' + empresaId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async deleteArchivo(archivoId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.delete(this.API_URI + 'archivo/archivo/' + archivoId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getChatList(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_ITURRIAPP + 'whatsapp/chat/historyPaginateByID', objeto).toPromise();
            return this.utilityService.parseDataAPI(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseDataAPI(responseError);
        }
    }
    public async getPictureContact(telefono: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_ITURRIAPP + `whatsapp/contact/getPictureByID/${telefono}`).toPromise();
            return this.utilityService.parseDataAPI(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseDataAPI(responseError);
        }
    }

    public async agregarDocumento(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'documento/documento', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async eliminarDocumento(documentoid: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'documento/eliminarDocumento/' + documentoid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async buscarPorDni(dni: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get('https://api.iturriapp.com/public/rest/microservice/search/dni/' + dni).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getSolicitudes_DescandoMedico(trabajadorID, pagina, registros, empresaId: any = environment.PARAM.TODOS)
        : Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI
                + `solicitud/getSolicitudPaginate/1/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getSolicitudes_Permiso(trabajadorID, pagina, registros, empresaId: any = environment.PARAM.TODOS)
        : Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI
                + `solicitud/getSolicitudPaginate/2/${trabajadorID}/${pagina}/${registros}/${empresaId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getTipoPermisoByGrupo(solicitudGrupo)
        : Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI
                + `solicitud/getTipoPermisoByGrupo/${solicitudGrupo}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async asignarEmpresa(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'trabajador/asignarEmpresa', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

}
